import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Forklift } from "lucide-react";

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer data-testid="main-footer" className="border-t border-gray-200 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 bg-yellow-400 rounded-sm flex items-center justify-center">
            <Forklift className="w-4 h-4 text-gray-900" />
          </div>
          <div className="leading-tight">
            <span className="font-heading text-sm font-bold text-gray-900 block">Fork Finder</span>
            <span className="text-[9px] text-gray-400 tracking-wide">by Gesti&oacute;n Farcar</span>
          </div>
        </div>
        <p className="text-sm text-gray-500">{t.footer.tagline}</p>
        <div className="flex items-center gap-3">
          <p className="text-xs text-gray-400">
            &copy; {new Date().getFullYear()} Gesti&oacute;n Farcar. {t.footer.rights}
          </p>
          <a
            href="/admin/login"
            data-testid="footer-admin-link"
            className="text-xs text-gray-300 hover:text-gray-500 transition-colors"
          >
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
